/* global __SERVER__ */

import React from 'react';
import { func, object, bool } from 'prop-types';
import { translate } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import qs from 'query-string';
import { connect } from 'react-redux';
import { compose } from 'redux';

import MainLayout from '@dragonfruit/layouts/MainLayout';

import SEOHead from '@dragonfruit/components/SEOHead';

import { getIsInapp } from '@dragonfruit/redux/location';
import { WEB, APP } from '@dragonfruit/constants/platformTypes';

import styles from './Privacy.scss';

const mapStateToProps = state => ({
  isInapp: getIsInapp(state),
});
/**
 * /privacy?platform=web ---> deliver web content
 * /privacy?platform=app ---> deliver app content
 */
function Privacy({ t, location: { search } = {}, isInapp }) {
  const { platform } = qs.parse(search);

  const seoComponent = (
    <SEOHead
      path="privacy"
      title={t('seo:seo.privacy.title')}
      description={t('seo:seo.privacy.description')}
    />
  );

  if (__SERVER__) {
    return seoComponent;
  }

  return (
    <MainLayout showHeader={!isInapp} showFooter={!isInapp}>
      {seoComponent}
      <section className={styles.container}>
        <div className={styles.row}>
          <div className={styles.content}>
            {(!platform || platform === WEB) && (
              <ReactMarkdown
                source={t('privacy.content.web')}
                escapeHtml={false}
              />
            )}

            {platform === APP && (
              <ReactMarkdown
                source={t('privacy.content.app')}
                escapeHtml={false}
              />
            )}
          </div>
        </div>
      </section>
    </MainLayout>
  );
}

Privacy.propTypes = {
  isInapp: bool.isRequired,
  location: object.isRequired,
  t: func.isRequired,
};

export default compose(
  translate(['privacy', 'seo']),
  connect(mapStateToProps)
)(Privacy);



// WEBPACK FOOTER //
// ./app/containers/Privacy/Privacy.jsx